import { autocomplete } from '@algolia/autocomplete-js';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { h, Fragment, render } from 'preact';
import { algoliaConfig } from '../_config.js';
import { getBrand } from '../_getBrand.js';
import { querySuggestionTemplate } from '../snippets/querySuggestionTemplate';
import { enhanceSearchForm } from '../_searchBoxA11y.js';

export function mountSRPSearchBox({ onQueryChange }) {
  const brand = getBrand();
  const config = algoliaConfig[brand];
  const mountPoint = document.querySelector('#algoliaSRPAutocomplete');
  const currentQuery = mountPoint.dataset.searchValue;

  const searchClient = algoliasearch(
    config.algolia.appId,
    config.algolia.apiKey
  );

  if (!mountPoint) return;

  // Un-hide the SSR input once JS takes over; autocomplete owns the UI from here
  mountPoint.removeAttribute('aria-hidden');

  autocomplete({
    container: mountPoint,
    initialState: { query: currentQuery },
    placeholder: '', // empty: no visible placeholder (+accessibility +UX)
    openOnFocus: true,
    detachedMediaQuery: 'none', // keep it inline here, not detached like the header modal
    enterKeyHint: 'enter',
    getSources() {
      return [
        {
          sourceId: 'querySuggestions',

          getItemUrl({ item }) {
            return `/search?q=${encodeURIComponent(item.query)}`;
          },

          getItems({ query }) {
            return searchClient.searchForHits({
              requests: [{
                indexName: 'query_suggestions',
                query,
                hitsPerPage: config.autocomplete.suggestions.hitsPerPage,
                highlightPreTag: '__aa-highlight__',
                highlightPostTag: '__/aa-highlight__',
              }],
            }).then(({ results }) => results[0].hits);
          },

          templates: {
            item: querySuggestionTemplate,
          },
        },
      ];
    },
    onSubmit({ state }) {
      // Fetch the brand-specific submit instructions
      if (!state.query) return;
      window.location.href = `/search?q=${encodeURIComponent(state.query)}`;
    },
  });

  // Icon-only label + text submit button after the input
  enhanceSearchForm(mountPoint);
}